<tiime-dialog (cancel)="cancel()">
  <mat-dialog-content class="dialog-content" mat-dialog-content data-cy="confirm-dialog-content">
    <span class="title" data-cy="confirm-dialog-title">Attention</span>
    <span class="message" data-cy="confirm-dialog-message">
      {{ confirmMessage() }}
    </span>
    @if (nextStatus() === ContractStatus.lost) {
      <br />
      <span class="message">
        Veuillez renseigner un motif de perte (obligatoire) et un commentaire (facultatif) qui ne seront plus
        modifiables ultérieurement.
      </span>
      <form tiimeFormColumn [formGroup]="lossForm">
        <app-code-and-label-select
          label="Motif de perte"
          [required]="true"
          [control]="lossForm.controls.lossReason"
          [errorMessage]="lossForm.lossReasonErrorMessage"
          [options]="contractLossReasons$ | async"
        ></app-code-and-label-select>
        <tiime-input-container contentId="comment" label="Commentaire">
          <textarea
            id="comment"
            placeholder="Commentaire"
            formControlName="lossComment"
            cdkTextareaAutosize
            cdkAutosizeMinRows="2"
            cdkAutosizeMaxRows="6"
          ></textarea>
        </tiime-input-container>
      </form>
    }
  </mat-dialog-content>
  <mat-dialog-actions class="dialog-actions">
    <button tiime-button color="accent" strocked large (click)="cancel()" data-cy="confirm-dialog-cancel-btn">
      Annuler
    </button>
    <button tiime-button color="accent" large raised (click)="confirm()" data-cy="confirm-dialog-confirm-btn">
      Confirmer
    </button>
  </mat-dialog-actions>
</tiime-dialog>
